import { render, staticRenderFns } from "./ReminderModal.vue?vue&type=template&id=3ec76a62&"
import script from "./ReminderModal.vue?vue&type=script&lang=js&"
export * from "./ReminderModal.vue?vue&type=script&lang=js&"
import style0 from "./ReminderModal.vue?vue&type=style&index=0&id=3ec76a62&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports